module.exports = __webpack_public_path__ + "static/media/arrow-circle-full.18291bf8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-full.svg
// module id = 147
// module chunks = 0